import { Link } from "react-router-dom"

/**
 * Footer — matches the marketing homepage footer so /privacy, /terms,
 * /404, and account/* share a single visual chrome with the landing
 * page.
 *
 * `currentYear` is captured at SSG build time and stays static in the
 * prerendered HTML; visitors don't run any date logic client-side.
 */

const currentYear = new Date().getFullYear()

export function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          <Link
            to="/"
            className="flex items-center gap-3 hover:opacity-90 transition-opacity"
            aria-label="GoodTalk — home"
          >
            <img
              src="/logoicon.png"
              alt="GoodTalk Logo"
              width={40}
              height={40}
              className="w-9 h-9 sm:w-10 sm:h-10"
            />
            <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-[#2193B0] to-[#6DD5ED] bg-clip-text text-transparent">
              GoodTalk
            </span>
          </Link>
          <p className="text-sm sm:text-base text-slate-400">
            © {currentYear} GoodTalk. Built for your growth.
          </p>
        </div>
      </div>
    </footer>
  )
}
